import { createSelector } from "reselect";
import { get } from "lodash";
export var selectAuthRequesting = function selectAuthRequesting(_ref) {
  var RouterReducer = _ref.RouterReducer;
  return RouterReducer.requesting;
};
export var getAuthFail = function getAuthFail(_ref2) {
  var RouterReducer = _ref2.RouterReducer;
  return RouterReducer.failed;
};
export var selectAuthenticated = function selectAuthenticated(_ref3) {
  var RouterReducer = _ref3.RouterReducer;
  return RouterReducer.authenticated;
};
export var selectUserProfile = function selectUserProfile(_ref4) {
  var RouterReducer = _ref4.RouterReducer;
  return RouterReducer.profile;
};
export var selectAuthState = createSelector([selectUserProfile, selectAuthenticated], function (profile, authenticated) {
  var agreedToEULA = get(profile, "agreed_to_eula") || false;

  if (authenticated === true && agreedToEULA === "Yes") {
    return true;
  }

  return false;
});